import * as e from "react";
import t from "../lib/SSRBase.es.js";
import c from "../defs/PlayCircle.es.js";
const r = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...o, weights: c }));
r.displayName = "PlayCircleIcon";
const m = r;
export {
  m as PlayCircle,
  r as PlayCircleIcon
};
